import React, { useState, useEffect, useContext } from "react";
import {Link} from "react-router-dom";
import { ResearchDashboardContext } from "../././researchDashboard/Context";
import {copyToClipboard, formatDate, searchContent,createElementFromHTML} from '../../utils/utilsHelpers';
import TableComponent from '../bootstrap/TableComponent';
import { TABLE_HEADER_CLASSES, LINK_CLASSES} from "../../constants/stylingConstants";
import {
    RESEARCH_DASHBOARD_INTERVIEWS_TABLE_HEADERS,
    RESEARCH_DASHBOARD_REFERENCE_CALLS_TABLE_HEADERS
} from "../../constants/reviewsConstants";
import Row from "react-bootstrap/Row";
import PeerTalkForm from "../peerTalk/PeerTalkForm";
import ResponseModal from "../modals/ResponseModal";

export default function ReviewResearchTable(props) {

    let { reviews, searchValue, researchType } = props;
    const [showPeerTalkModal, setShowPeerTalkModal] = useState(false);
    const [selectedExpert, setSelectedExpert] = useState(null);
    const [selectedReview, setSelectedReview] = useState(null);
    const [showPeerTalkResponse, setShowPeerTalkResponse] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    const { data,
        token,
        selectedProduct,
        callsRequested,
        setCallsRequested,
        currentUser,
        setCurrentUser,
        reCaptchaKey,
        onToggleAudio,
        smarter_questions,
        onSmarterQuestionsAnswered,
        onToggleRegistration,
        onToggleLeadGen
    } = useContext(ResearchDashboardContext);

    // Also in props: sortDataViaKey

    // events

    const onPeerTalkToggle = (review) => {
        setIsCancelling(false);
        setSelectedReview(review);
        setSelectedExpert({ ...review.author, industry: review.industry, job_function: review.job_function});
        onToggleLeadGen({
            key: review.id,
            leadCode: 'INQUIRY_CALL',
            includePeerTalk: true,
            cta: `Request a call with ${review.author.username}`,
            actionParams: {
                product: {
                    id: selectedProduct.id,
                    name: selectedProduct.name,
                    category: { id: selectedProduct.category.id },
                    smarter_questions: selectedProduct?.smarter_questions
                },
                smarter_questions: smarter_questions,
                selected: { ...review.author, industry: review.industry, job_function: review.job_function},
            },
            confirmationParams: {
                header: 'Thank you',
                subHeader: 'Your request has been sent successfully. We will contact the peer to coordinate the call and get back to you.' },
            hiddenTags: {
                ...review.lead_gen_attributes, todo: 'inquiry_call', itemid: review.author.id, 'lead[lead_code]': 'INQUIRY_CALL' }
        })
    }

    const onPeerTalkCancel = (review) => {
        setIsCancelling(true);
        setSelectedExpert({ ...review.author, industry: review.industry, job_function: review.job_function});
        setShowPeerTalkModal(true);
    }

    const onPeerTalkMessageSent = () => {
        setShowPeerTalkModal(false);
        if(isCancelling) {
            let callIds = callsRequested.filter((c) => c !== selectedExpert.id);
            setCallsRequested(callIds);
            setShowPeerTalkResponse(true); // for now only show this on cancel request
        } else {
            setCallsRequested([...callsRequested, selectedExpert?.id]);
        }
    }

    const onHandleCloseResponse = () => {
        setShowPeerTalkResponse(false);
        setSelectedExpert(null);
        setIsCancelling(false);
    }

    const onAudioListen = (review) => {
        // turn this into LeadGen if we want to go through phone verification, etc...
        if(currentUser) {
            onToggleAudio(review.actions.audio.url, review.actions.audio.type, review.id)
        } else {
            let productId = selectedProduct.id;
            onToggleLeadGen({ key: review.id,
                withConfirmationScreen: false,
                cta: 'Register',
                leadCode: 'AUDIO_HIGHLIGHT',
                actionParams: {
                    selected: { url: review.actions.audio.url, type: review.actions.audio.type },
                },
                hiddenTags: {
                    ...review.lead_gen_attributes, 'todo': 'generic_lead', itemid: productId, 'lead[lead_code]': 'AUDIO_HIGHLIGHT' }});
        }
    }

    // render methods

    const renderPeerTalkModal = () => {
        if(showPeerTalkModal) {
            return (
                <PeerTalkForm
                    productId={selectedProduct.id}
                    productName={selectedProduct.name}
                    categoryId={selectedProduct.category.id}
                    isCancelling={isCancelling}
                    questions={smarter_questions}
                    answeredQuestions={selectedProduct?.smarter_questions}
                    onSmarterQuestionsAnswered={onSmarterQuestionsAnswered}
                    // gdpr={props.gdpr}
                    show={showPeerTalkModal}
                    setShow={setShowPeerTalkModal}
                    selectedExpert={selectedExpert}
                    currentUser={currentUser}
                    // updateCurrentUser={setCurrentUser}
                    onMessageSent={onPeerTalkMessageSent}
                    token={token}
                />
            )
        }
    }

    const renderPeerTalkResponseModal = () => {
        if(showPeerTalkResponse) {
            let message = (isCancelling) ?
                `We have cancelled your call request with ${selectedExpert.username}.` :
                `Thank you for your interest. We will contact you soon to schedule a meeting with ${selectedExpert.username}.`;

            return (
                <ResponseModal
                    modalSize={'sm'}
                    bgColor={'soft-success'}
                    textColor={'success'}
                    showIcon={false}
                    message={message}
                    show={!!showPeerTalkResponse}
                    centered={false}
                    textAlignment={'start'}
                    btnClose={false}
                    borderColor={'success'}
                    dialogClasses={'modal-bottom-notice'}
                    showBackdrop={false}
                    autoClose={true}
                    btnColor={'success'}
                    handleShow={onHandleCloseResponse}
                />
            )
        }
    }


    const tableHeadersReviews = () => {
        return (
            <tr className={'sortable border-bottom border-dark'}>
                {RESEARCH_DASHBOARD_INTERVIEWS_TABLE_HEADERS.map((col,i) => {
                    if(col.sort) {
                        return (
                            <th onClick={() => props.sortDataViaKeyHandler(col.sortOn)} className={TABLE_HEADER_CLASSES} key={`col-${i}`} style={ col.styles || {}}>
                                {col.item}
                            </th>
                        )
                    } else {
                        return (
                            <th data-sortable={false}  key={`col-${i}`}>{col.item}</th>
                        )
                    }
                })}
            </tr>
        )
    }

    const tableRowsReviews = () => {
        return (
            reviews && reviews.map((review, index) => {
                let isLastItem = (index === reviews.length - 1)
                return (
                    <tr key={index} className={'content-styling font-18 border-bottom'}>
                        <td>{review.industry}</td>
                        <td>{createElementFromHTML(review.job_function)}</td>
                        <td>{review.company_size}</td>
                        <td className={'text-nowrap'}>{formatDate(review.published_date, 'MMM YYYY')}</td>
                        <td>{review.rating !== 0 && review.ten_point_rating}</td>
                        <td>
                            <Link to={`/peer-research/review/${review.id}`}
                                  className={'btn btn-outline-secondary btn-sm'}
                                  data-gtm-event-region='peer-research-interviews-table'
                                  data-gtm-event-element='view'>
                                View
                            </Link>
                        </td>
                        <td className={'text-nowrap'}>
                            {review.actions.audio?.url && <a className={LINK_CLASSES} onClick={() => onAudioListen(review)}
                                                             data-gtm-event-region='peer-research-interviews-table' data-gtm-event-element='listen'>
                                <i className={'fas fa-headphones pe-1'}></i>
                                <span className={'fw-bolder'}>Listen</span>
                            </a>}
                        </td>
                        <td>
                            {currentUser ? <a className={LINK_CLASSES} data-gtm-event-region={'peer-research-interviews-table'} data-gtm-event-element={'download'}
                                              onClick={() => onToggleLeadGen({
                                directReportUrl: review.actions.pdf,
                                directReportDownload: true,
                                reportTopic: `${selectedProduct.name} interview by ${review.author.username}`,
                                withConfirmationScreen: false,
                                leadCode: 'DOWNLOAD_REPORT',
                                hiddenTags: { ...review.lead_gen_attributes  }
                            })}>
                                    <i className={'fas fa-download pe-1'}></i>
                            </a>
                             : <a className={LINK_CLASSES} href={review.actions.pdf}
                                    data-gtm-event-region={'peer-research-interviews-table'} data-gtm-event-element={'download'}><i className={'fas fa-download pe-1'}></i></a>}
                        </td>
                        <td>
                            <div className={'dropdown'}>
                                <a className={'dropdown-toggle link-dark px-0'} data-bs-toggle={'dropdown'} data-bs-target={`#review_admin_${review.id}`}>
                                    <i className={'fas fa-ellipsis-v'}></i>
                                </a>
                                <div className={`dropdown-menu dropdown-menu-end rounded font-13 py-1 mt-1 ${isLastItem && 'dropdown-menu-up'}`} id={`#review_admin_${review.id}`}>
                                    <a
                                      className={'dropdown-item border-bottom'}
                                      onClick={() => { copyToClipboard(review.actions.full_url) }}
                                      data-gtm-event-region='peer-research-interviews-table'
                                      data-gtm-event-element='share'>
                                        <i className={'fal fa-share-nodes me-2'}></i>
                                        Share
                                    </a>
                                </div>
                            </div>
                        </td>
                    </tr>
                )
            })
        )
    }

    const tableHeadersPeers = () => {
        return (
            <tr className={'sortable border-bottom border-dark'}>
                {RESEARCH_DASHBOARD_REFERENCE_CALLS_TABLE_HEADERS.map((col,i) => {
                    if(col.sort) {
                        return (
                            <th onClick={() => props.sortDataViaKeyHandler(col.sortOn)} className={TABLE_HEADER_CLASSES} key={`col-${i}`} style={ col.styles || {}}>
                                {col.item}
                            </th>
                        )
                    } else {
                        return (
                            <th data-sortable={false}  key={`col-${i}`}>{col.item}</th>
                        )
                    }
                })}
            </tr>
        )
    }

    const tableRowsPeers = () => {
        return (
            reviews && reviews.map((review, index) => {
                return (
                    <tr key={index} className={'content-styling font-18 border-bottom'}>
                        <td>{review.industry}</td>
                        <td>{review.company_size}</td>
                        <td>{createElementFromHTML(review.job_function)}</td>
                        <td>
                            { callsRequested.includes(review.author.id) ?
                                <a
                                  className={`text-red ${LINK_CLASSES} text-nowrap`}
                                  onClick={() => onPeerTalkCancel(review)}
                                  data-gtm-event-region='peer-research-inquiry-calls'
                                  data-gtm-event-element='cancell-call'>
                                    <i className={'fal fa-phone-slash pe-1'}></i>
                                    Cancel call
                                </a> : <a className={`${LINK_CLASSES} text-nowrap`}
                                          onClick={() => onPeerTalkToggle(review)}
                                          data-gtm-event-region='peer-research-inquiry-calls'
                                          data-gtm-event-element='request-call'>
                                    <i className={'fas fa-phone pe-1'}></i>
                                    Request call
                                </a> }
                        </td>
                        <td>
                            <a
                              href={review.author.url}
                              className={`${LINK_CLASSES} text-nowrap`}
                              data-gtm-event-region='peer-research-inquiry-calls'
                              data-gtm-event-element='reviewers-profile'
                              target={'_blank'}>
                                <i className={'fas fa-user pe-1'}></i>
                                View profile
                            </a>
                        </td>
                    </tr>
                )
            })
        )
    }

    return (
        <Row className={'overflow-x-auto'}>
            <TableComponent
                tableHeaders={ researchType === 'reviews' ? tableHeadersReviews() : tableHeadersPeers() }
                tableRows={ researchType === 'reviews' ? tableRowsReviews() : tableRowsPeers()}
                isCentered='true'
                isStriped={true}
                tableAlignment={'align-middle'}
            />
            {renderPeerTalkModal()}
            {renderPeerTalkResponseModal()}
        </Row>
    )
}
